import React from "react";

function Logo(props) {
  return (
    <img alt="Logo" src="/static/marilao_logo.png" {...props} width={50} />
  );
}

export default Logo;
